if (!customElements.get('grs-navigation')) {
  customElements.define('grs-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.mobile = matchMedia('(max-width: 1099px)');
      this.shell = this.querySelector('.grs-nav__shell');
      this.toggle = this.querySelector('.grs-nav__toggle');
      this.groups = [...this.querySelectorAll('.grs-nav__group')];
      this.listen(this.toggle, 'click', () => this.openMobile());
      this.listen(this.querySelector('.grs-nav__close'), 'click', () => this.closeMobile());
      this.listen(this.querySelector('.grs-nav__backdrop'), 'click', () => this.closeGroups());
      this.groups.forEach(group => {
        this.listen(group, 'toggle', () => {
          if (group.open) this.groups.forEach(other => { if (other !== group) other.open = false; });
          this.toggleAttribute('data-expanded', this.groups.some(item => item.open));
        });
      });
      this.listen(document, 'click', event => {
        if (!this.contains(event.target)) this.closeGroups();
      });
      this.listen(document, 'keydown', event => {
        if (event.key === 'Escape') {
          if (this.hasAttribute('data-mobile-open')) {
            event.preventDefault(); this.closeMobile();
          } else {
            const group = this.groups.find(item => item.open);
            if (group) { event.preventDefault(); this.closeGroups(); group.querySelector('summary').focus(); }
          }
        }
        if (event.key === 'Tab' && this.hasAttribute('data-mobile-open')) {
          const items = [...this.shell.querySelectorAll('a[href],button,input,summary')].filter(el => el.getClientRects().length && !el.disabled && (!el.closest('details:not([open])') || el.matches('summary')));
          const first = items[0], last = items[items.length - 1];
          if (event.shiftKey && (document.activeElement === first || !this.shell.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && (document.activeElement === last || !this.shell.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
        }
      });
      this.listen(this, 'focusout', () => {
        requestAnimationFrame(() => { if (!this.mobile.matches && !this.contains(document.activeElement)) this.closeGroups(); });
      });
      this.listen(this.mobile, 'change', () => { this.closeMobile(false); this.closeGroups(); });
      this.listen(document, 'shopify:block:select', event => {
        if (this.contains(event.target)) {
          if (this.mobile.matches) this.openMobile();
          const group = event.target.closest('.grs-nav__group');
          if (group) group.open = true;
        }
      });
    }
    listen(target, name, handler) { target.addEventListener(name, handler, { signal: this.controller.signal }); }
    closeGroups() { this.groups.forEach(group => { group.open = false; }); this.removeAttribute('data-expanded'); }
    openMobile() {
      if (!this.mobile.matches) return;
      this.closeGroups();
      this.setAttribute('data-mobile-open', '');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.shell.setAttribute('role', 'dialog');
      this.shell.setAttribute('aria-modal', 'true');
      document.body.classList.add('grs-menu-open');
      this.inertElements = [...document.querySelectorAll('#cs_content,#cs_footer')].filter(el => !el.inert);
      this.inertElements.forEach(el => { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); });
      this.querySelector('.grs-nav__close').focus();
    }
    closeMobile(restoreFocus = true) {
      const wasOpen = this.hasAttribute('data-mobile-open');
      this.removeAttribute('data-mobile-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.shell.removeAttribute('role');
      this.shell.removeAttribute('aria-modal');
      document.body.classList.remove('grs-menu-open');
      (this.inertElements || []).forEach(el => { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); });
      if (wasOpen) { this.closeGroups(); if (restoreFocus) this.toggle.focus(); }
    }
    disconnectedCallback() { this.closeMobile(false); this.controller.abort(); }
  });
}
